var _defs, _text, _text2, _text3, _text4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 472,
    height: 472,
    viewBox: "0 0 472 472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        font-size: 200px;\n        font-family: \"Elastic Stretch\";\n      }\n\n      .cls-2 {\n        fill: #fb0404;\n      }\n\n      .cls-3 {\n        font-size: 41.667px;\n        fill: #020000;\n        font-family: \"Typo Round Bold Demo\";\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "M",
    className: "cls-1",
    x: 4.129,
    y: 295.505
  }, "M")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "A",
    className: "cls-1",
    x: 172.672,
    y: 295.194
  }, "A")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "D",
    className: "cls-2",
    transform: "matrix(-1, 0, 0, 1, 467.321, 295.653)"
  }, "D")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "SECURITY_SYSTEMS",
    "data-name": "SECURITY SYSTEMS",
    className: "cls-3",
    transform: "translate(66.858 334.542) scale(0.939 0.609)"
  }, "SECURITY SYSTEMS")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ff9cbe250489ef9f5c00dc0b76f82e2.svg";
export { ForwardRef as ReactComponent };